import { funcState } from '../../utils/funcState';
import { Filters } from '../utils/filtersEnum';

const DistancesFilterProvider = ({ updateFilter }) => {
  const [lastCategoryData, setLastCategoryData] = funcState();
  const [availableDistances, setAvailableDistances] = funcState([]);
  const [selectedDistanceIds, setSelectedDistanceIds] = funcState([]);

  const getSelectedDistanceValues = () => {
    return selectedDistanceIds.value
      .map((distanceId) =>
        availableDistances.value.find((ad) => ad.id === distanceId),
      )
      .filter(Boolean);
  };

  const update = ({ categoryData, queryParams }) => {
    setLastCategoryData(categoryData);
    setAvailableDistances(
      categoryData?.sport?.distances?.filter(
        ({ label }) => label !== 'Other', // removes "Other" Distance Category
      ) ?? [],
    );
    const categorySportDistance = categoryData?.query?.sportDistance;
    const queryParamsSportDistances = queryParams.sportDistances;

    const internalUpdate = () => {
      updateFilter({
        key: Filters.Distance,
        value: {
          selectedDistances: getSelectedDistanceValues(),
          availableDistances: availableDistances.value,
        },
      });
    };

    if (categorySportDistance) {
      setSelectedDistanceIds([categorySportDistance]);
      return internalUpdate();
    }

    if (queryParamsSportDistances) {
      if (
        Array.isArray(queryParamsSportDistances) &&
        queryParamsSportDistances.length
      ) {
        setSelectedDistanceIds(
          queryParamsSportDistances.map((id) => parseInt(id, 10)),
        );
        return internalUpdate();
      }

      setSelectedDistanceIds([parseInt(queryParamsSportDistances, 10)]);
      return internalUpdate();
    }

    setSelectedDistanceIds([]);
    return internalUpdate();
  };

  const setDistances = ({ distanceIds }) => {
    setSelectedDistanceIds(distanceIds);

    updateFilter({
      key: Filters.Distance,
      value: {
        selectedDistances: getSelectedDistanceValues(),
        availableDistances: availableDistances.value,
      },
    });
  };

  const toQueryParams = () => ({ sportDistances: selectedDistanceIds.value });

  const pushHistory = (obj) => {
    const categoryData = lastCategoryData.value;

    if (
      categoryData?.query?.sportDistance &&
      obj?.sportDistances?.length !== undefined
    ) {
      const nearestSportCat = categoryData.parents.find(
        (n) => n.type === 'Distance',
      );

      if (nearestSportCat) {
        return `/${nearestSportCat.path}`;
      }
    }

    return null;
  };

  const defaultFilters = {
    sportDistances: undefined,
  };

  const hasActiveFilters = () => {
    return !!selectedDistanceIds.value.length;
  };

  return {
    exposed: { setDistances },
    toQueryParams,
    update,
    pushHistory,
    hasActiveFilters,
    defaultFilters,
  };
};

export default DistancesFilterProvider;
